import { useQuery } from "@tanstack/react-query";
import { intakes, type IntakeSearchFilters } from "@/lib/intakeApi";

// Intake list with pagination
export function useIntakes(filters?: IntakeSearchFilters) {
  return useQuery({
    queryKey: ["intakes", "list", filters],
    queryFn: () => intakes.list(filters),
    staleTime: 5 * 60 * 1000, // 5 minutes - matches API cache TTL
  });
}

// Single intake detail
export function useIntake(recordId: string) {
  return useQuery({
    queryKey: ["intakes", "detail", recordId],
    queryFn: () => intakes.getById(recordId),
    enabled: !!recordId,
    staleTime: 1 * 60 * 1000, // 1 minute - matches API cache TTL
  });
}

// Field mapping (admin only)
export function useIntakeFieldMapping() {
  return useQuery({
    queryKey: ["intakes", "fieldMapping"],
    queryFn: () => intakes.getFieldMapping(),
    staleTime: 30 * 60 * 1000, // 30 minutes - field mapping rarely changes
  });
}